let curriculum = {};

export const setCurriculum = (content) => {
  curriculum = content;
};

export const getCurriculum = () => curriculum;
